module.exports = __webpack_public_path__ + "static/media/model.88c4dad8.glb";